// SPDX-License-Identifier: Apache-2.0

import ChannelID from "../api/types/channelID";
import ChannelState from "../api/types/channelState";
import Address from "../api/types/address";

/**
 * The representation of a channel for the client.
 */
export default class Channel {
  private readonly _id: ChannelID;
  private readonly _peerAddressEth: Address;
  private readonly _peerAddressCC: string;
  private _state: ChannelState;

  constructor(
    id: ChannelID,
    peerAddressEth: Address,
    peerAddressCC: string,
    state: ChannelState,
  ) {
    this._id = id;
    this._peerAddressEth = peerAddressEth;
    this._peerAddressCC = peerAddressCC;
    this._state = state;
  }

  /**
   * @returns The ethereum address of the other peer of the channel.
   */
  get peerAddressEth(): Address {
    return this._peerAddressEth;
  }

  /**
   * @returns The stellar address of the other peer of the channel.
   */
  get peerAddressCC(): string {
    return this._peerAddressCC;
  }

  /**
   * @returns The channel ID.
   */
  get id(): ChannelID {
    return this._id;
  }

  /**
   * @returns The current state.
   */
  get state(): ChannelState {
    return this._state;
  }

  /**
   * Sets the current state to the given one.
   *
   * @param newState -
   */
  updateState(newState?: ChannelState): void {
    if (newState) {
      this._state = newState;
    }
  }

  /**
   * @returns The current balance of the client.
   */
  get myBalance(): bigint[] {
    return this._state.balance;
  }

  /**
   * @returns The current balance of the other peer.
   */
  get peerBalance(): bigint[] {
    return this._state.peerBalance;
  }
}
